import React from 'react'
import { connect } from 'react-redux'
import { withSiteData } from 'react-static'

import OrderList from '../components/OrderList'
import {createOrder} from '../actions/orders'

const Orders = withSiteData(({orders, companyData, createOrder}) =>
  <React.Fragment>
    <div className="row">
      <div className="col-sm-12">
        <div className="page-title-box">
          <h4 className="page-title">Aufträge</h4>
          <div className="clearfix"/>
        </div>
      </div>
    </div>

    <div className="row">
      <div className="col-12">
        <OrderList orders={orders.items} createOrder={createOrder} companyData={companyData} />
      </div>
    </div>
  </React.Fragment>
)

export default connect(
  state => {
    const account = state.account.accessibleAccounts.find(a =>
      a.id===state.account.currentAccountId
    )

    return {
      orders: state.orders,
      companyData: account && account.company
    }
  },
  dispatch => ({
    createOrder: (order) => dispatch(createOrder(order))
  })
)(Orders)



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/Orders.js